var Component = require("!../../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.1.2.8@vux-loader/src/script-loader.js!../../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./Global.vue"),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/vue/Global.vue
// module id = 246
// module chunks = 17